import { currentUserIdState } from '@/state/auth.state';
import type { UserId } from '@rock/types';
import { UserIdSchema } from '@rock/types';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

/** The signed-in admin's id, parsed as a `UserId` — what a decision is recorded `by`. Undefined until signed in. */
export function useCurrentUserId(): UserId | undefined {
    const raw = useAtomValue(currentUserIdState);
    return useMemo(() => (raw ? UserIdSchema.parse(raw) : undefined), [raw]);
}
